import React, { Component } from "react";
import PropTypes from "prop-types";
import { isUndefined } from "lodash";
import { toast } from "react-toastify";
import Pagination from "./Pagination";
import RowCount from "./RowCount";
import DeletePopup from "./DeletePopup";

class Table extends Component {
  /**
   * Required or Optional props details of this component
   *
   * pageTitleLeft - Grid current page title.
   * managementType - Current Management type name need to pass
   * grid - grid object
   * data - Pass response which need to display in grid
   * rowStatus - Pass response of status update of each row
   * rowDelete - Pass response of delete of each row
   */
  static propTypes = {
    grid: PropTypes.object.isRequired,
    rowStatus: PropTypes.object,
    // rowDelete: PropTypes.object
  };

  constructor(props) {
    super(props);

    this.recordDeleted = this.recordDeleted.bind(this);
    this.recordStatusUpdated = this.recordStatusUpdated.bind(this);
    this.data = [];
    this.fixedActionSet = false;
  }

  /**
   * Handle the delete record response
   *
   * @param object
   */
  recordDeleted(props) {
    const response = props.rowDelete.response;
    if (props.rowDelete.isFetching !== this.props.rowDelete.isFetching) {
      if (!props.rowDelete.isFetching && !props.rowDelete.isError) {
        // Check whether response status is success or not
        // If success, then allow user to login
        // If fail, then display the error message
        // if (response.status && response.status === 200) {
        toast.success(response.message || "Record deleted successfully.");
        // Refresh the customer list after delete the record.
        // So call the grid list again
        props.grid.getRecordsAfterDelete();
        // } else {
        //   toast.error(
        //     response.message || this.props.locale.common.remove.error
        //   );
        // }
      } else if (props.rowDelete.isError) {
        toast.error(
          (response.error &&
            response.error.message &&
            response.error.message.message) ||
            "There was an issue deleting the record, please try again."
        );
        // const errorMessage =
        //   (response.error && response.error.message && ) ||
        //   "There was an issue deleting the record, please try again.";
        // toast.error(errorMessage);
      }
    }
  }

  /**
   * Handle the record status update response
   *
   * @param object
   */
  recordStatusUpdated(props) {
    const response = props.rowStatus.response;
    if (props.rowStatus.isFetching !== this.props.rowStatus.isFetching) {
      if (!props.rowStatus.isFetching && !props.rowStatus.isError) {
        // Check whether response status is success or not
        // if (
        //   this.props.rowStatus.status &&
        //   this.props.rowStatus.status === 204
        // ) {
        toast.success(response.message || "Status Updated Successfully.");
        // Refresh the customers list after delete the record.
        // So call the grid list again
        props.grid.getRecords();
        // } else {
        //   toast.error(
        //     response.message ||
        //       "this.props.locale.common.remove.error==========="
        //   );
        // }
      } else if (props.rowStatus.isError) {
        toast.error(
          response.message || "Problem in updating status, please try again"
        );
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    // Delete customer
    if (!isUndefined(nextProps.rowDelete)) {
      this.recordDeleted(nextProps);
    }
    // Status update
    if (!isUndefined(nextProps.rowStatus)) {
      this.recordStatusUpdated(nextProps);
    }
  }

  render() {
    const {
      data: {
        response: { count },
      },
      children,
      grid,
    } = this.props;

    return (
      <React.Fragment>
        {/* Delete confirmation box */}
        <DeletePopup
          ref={(node) => {
            this.delete = node;
          }}
          grid={grid}
        />
        {/* {data.isFetching && <Loader />} */}

        {children}

        <div className="col-sm-12 page-margin trip-pad">
          <div className="nav-flex flex-end">
            <div className="row-b">
              <RowCount grid={grid} />
              <Pagination grid={grid} totalRecords={count || 0} />
            </div>
          </div>
        </div>
        {/* {!data.isFetching &&
          data.response.data &&
          data.response.data.length > 0 && (
            <Pagination
              {...this.props}
              grid={grid}
              currentPage={grid.currentPage}
              rows={grid.rowsPerPage}
              totalRecords={data.response.totalRecords}
            />
          )} */}
      </React.Fragment>
    );
  }
}

export default Table;
